import { ConstraintItemType, ConstraintScope } from './constraint';

export interface ConstraintModifier {
  name: string;
  action: ConstraintModifierAction;
  field: ConstraintModifierField;
  value: string;
  conditions: ConstraintModifierCondition[];
  repeats: ConstraintModifierRepeater[];
  childId: string | null;
  childType: ConstraintItemType | null;
}

export enum ConstraintModifierAction {
  Increment = 'Increment',
  Decrement = 'decrement',
  Set = 'Set',
  Append = 'Append',
}

export enum ConstraintModifierField {
  Point = 'Point',
  Hidden = 'Hidden',
  Name = 'Name',
  Constraint = 'Constraint',
}

export interface ConstraintModifierCondition {
  name: string;
  field: ConstraintModifierConditionField;
  scope: ConstraintScope;
  value: string;
  percentValue: boolean;
  shared: boolean;
  includeChildSelections: boolean;
  includeChildForces: boolean;
  childId: number | null;
  childType: ConstraintItemType | null;
  type: ConstraintModifierConditionType;
}

export enum ConstraintModifierConditionField {
  Selections = 'Selections',
  Point = 'Point',
}

export enum ConstraintModifierConditionType {
  AtLeast = 'AtLeast',
  EqualTo = 'EqualTo',
  AtMost = 'AtMost',
}

export interface ConstraintModifierRepeater {
  name: string;
  field: ConstraintModifierRepeaterField;
  scope: ConstraintScope;
  value: string;
  percentValue: boolean;
  shared: boolean;
  includeChildSelections: boolean;
  includeChildForces: boolean;
  childId: number | null;
  childType: ConstraintItemType | null;
  repeats: boolean;
  roundUp: boolean;
}

export enum ConstraintModifierRepeaterField {
  Selections = 'Selections',
  Point = 'Point',
}
